import React from 'react';

import { AuthProvider } from './Auth';
import { ReactQueryProvider } from './ReactQuery';
import { ReduxProvider } from './Redux';

const Providers = ({ children }: { children: React.ReactElement }) => (
  <AuthProvider>
    <ReduxProvider>
      <ReactQueryProvider>{children}</ReactQueryProvider>
    </ReduxProvider>
  </AuthProvider>
);

export default Providers;
